module.exports = __webpack_public_path__ + "img/shakeys_menu_2.18aea9b0.jpg";